module.exports = __webpack_public_path__ + "media/images/sample/ic_placeholder-79125e86325351718afac89ec6476333.svg";